module.exports = __webpack_public_path__ + "img/2-lonely-bear_v8e_loading.9a3e6ea0.jpg";